import {
  createResourceQueryAtom,
  defineResource,
  defineResourceQuery,
} from "#/shared/lib/resource";

import { getStoreConnection } from "../api/get-store-connection";

const storeConnectionResource = defineResource("store-connection");

const storeConnectionQuery = defineResourceQuery({
  key: () => [],
  name: "detail",
  queryFn: () => getStoreConnection(),
  resource: storeConnectionResource,
  refetchOnWindowFocus: "always",
  staleTime: 30_000,
});

/** 后台首屏的店铺接入读模型。调用方只消费这个 atom，不自己拼 query key。 */
export const storeConnectionAtom = createResourceQueryAtom(
  storeConnectionQuery,
  () => undefined,
);
